module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DIV', {
    staticClass: "content-wrapper"
  }, [(_vm.serverData.loadingDataStatus.mainCommonData != _vm.serverData.loadingDataStatus.types.LOADED) ? _c('div', {
    staticClass: "loading-text"
  }, [_vm._v("\n  Подождите, загружаются общие данные\n")]) : (_vm.serverData.loadingDataStatus.places != _vm.serverData.loadingDataStatus.types.LOADED) ? _c('div', {
    staticClass: "loading-text"
  }, [_vm._v("\n  Подождите, загружаются данные по площадкам\n")]) : (_vm.place == null) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-circle-left back-button"
  })]), _vm._v(" "), _c('div', {
    staticClass: "placenotfound-text"
  }, [_vm._v("Площадка не найдена")])]) : _c('div', {
    staticClass: "place"
  }, [_c('div', {
    staticClass: "place-image",
    style: ({
      'background-image': 'url(' + _vm.serverData.imagesGetURL(_vm.place.val.images[0]) + ')'
    }),
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-circle-left back-button-over"
  }), _vm._v(" "), (_vm.isActiveUserAdmin()) ? _c('i', {
    staticClass: "fas fa-edit back-button-over-right",
    on: {
      "click": function($event) {
        _vm.goToPlaceEdit(_vm.place.val.id)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "10px 0 0 0",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "place-name"
  }, [_vm._v(_vm._s(_vm.place.val.name))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "30px 0 0 0",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "place-prop"
  }, [_vm._v("Адрес:")]), _vm._v(" "), _c('div', {
    staticClass: "place-prop"
  }, [_vm._v(_vm._s(_vm.place.val.city) + ", " + _vm._s(_vm.place.val.address))])]), _vm._v(" "), (_vm.place.val.description != '') ? _c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "20px 0 0px 0",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "place-prop"
  }, [_vm._v("Описание:")]), _vm._v(" "), _c('div', {
    staticClass: "place-prop"
  }, [_vm._v(_vm._s(_vm.place.val.description))])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f624111","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Place.vue
// module id = 353
// module chunks = 0